import { SET_NCAP_ENABLED, SET_SYSTEM_SETTINGS_STATUS } from 'store/actions/actionTypes';
import { APP_STATUS } from 'types/app';

interface ISystemSettingsState {
  ncapEnabled: boolean;
  status: APP_STATUS;
}

export const INITIAL_STATE: ISystemSettingsState = {
  ncapEnabled: true, // Default to true
  status: APP_STATUS.IDLE,
};

const systemSettingsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_NCAP_ENABLED: {
      return {
        ...state,
        ncapEnabled: action.payload,
      };
    }

    case SET_SYSTEM_SETTINGS_STATUS: {
      return {
        ...state,
        status: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default systemSettingsReducer;

